import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { DrugPlan } from '../../models/drug-plan'
import { PlanList } from '../../models/plan-list'
import { Notes } from '../../models/notes'
import { EnrollmentElectionType } from '../../models/enrollment-election-type'
import { Step4Model } from '../../models/Step4Model'
import { DataEntryStep1 } from '../../models/data-entry-step1'
import { BeneficiaryInfo } from '../../models/enrollments'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { SubmitEnrollmentDataResponse } from '../../models/submit-enrollment-data-response'
import { PortalGlobals } from '../../../portalglobals'
import * as moment from 'moment'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../models/EnrollmentCacheData'

@Component({
    selector: 'ExternalAgentStep4',
    templateUrl: 'external-agent-step4.html'
})
export class ExternalAgentStep4 implements OnInit {
    drugPlanModel = {} as DrugPlan
    notesModel = {} as Notes
    planList = [] as PlanList[]
    enrollmentElectionTypes: EnrollmentElectionType[] = [new EnrollmentElectionType()]
    paymentMethod: BeneficiaryInfo
    step4Model: Step4Model
    step1Model: DataEntryStep1
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    AccountName: string
    AccountType: string | null
    AgentName: string
    DataEntryAgentName: string
    hasError: boolean
    ErrorMessages: any[]
    userPofilename: string
    agentID: string
    appDate: string
    effDate: string
    gender: string
    dob: string
    medAdate: string
    medBDate: string
    sepEffDate: string
    showSepEffDate: boolean
    public loading: boolean = false
    EOBFlag: string
    Accessible: string
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    DisEnrllEffDate: string
    DisEnrllNoticeDate: string
    PaperlessOption: boolean
    visibleFrom2025: boolean

    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, private _portalGlobal: PortalGlobals) {
        this.step4Model = {} as Step4Model
        this.step4Model.notes = {} as Notes
        this.step4Model.prescriptionDrug = {} as DrugPlan
        this.paymentMethod = {} as BeneficiaryInfo
        this.ErrorMessages = [] as any[]
        this.EOBFlag = ''
        this.Accessible = ''
    }

    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._portalGlobal.currentUser = JSON.parse(User!)

        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        this.agentID = this._portalGlobal.currentUser.userProfileName
        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.enrollment === null || this.enrollment === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1'])
        }

        if (this.enrollment.AGENTID === null || this.enrollment.AGENTID === undefined || this.enrollment.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.loading = true
                        this.enrollment = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollment.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollment.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollment.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollment.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollment.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollment.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollment.ACCESSKEY = this.enrollmentCacheData.ACCESSKEY
                        this.enrollment.ENROLLMENTID = this.enrollmentCacheData.ENROLLMENTID
                        this.enrollment.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT
                        this.enrollment.FORMNAME = this.enrollmentCacheData.FORMNAME
                        this.enrollment.PaperlessSettings = this.enrollmentCacheData.PaperlessSettings

                        this.LoadData()

                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1'])
            }
        } else {
            this.LoadData()
        }
    }

    LoadData(): void {
        this.appDate = this.enrollment.APPDT == undefined ? '' : moment(this.enrollment.APPDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.effDate = this.enrollment.EFFDT == undefined ? '' : moment(this.enrollment.EFFDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.dob = this.enrollment.APPDOB == undefined ? '' : moment(this.enrollment.APPDOB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.medAdate = this.enrollment.MEDA == undefined ? '' : moment(this.enrollment.MEDA, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.medBDate = this.enrollment.MEDB == undefined ? '' : moment(this.enrollment.MEDB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.sepEffDate = this.enrollment.SEPEFFDT == undefined ? '' : moment(this.enrollment.SEPEFFDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')

        this.DisEnrllEffDate =
            this.enrollment.DISENROLLDATE === undefined || this.enrollment.DISENROLLDATE === null || this.enrollment.DISENROLLDATE === ''
                ? ''
                : moment(this.enrollment.DISENROLLDATE, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.DisEnrllNoticeDate =
            this.enrollment.DISENROLLNOTICEDT == undefined || this.enrollment.DISENROLLNOTICEDT === null || this.enrollment.DISENROLLNOTICEDT === ''
                ? ''
                : moment(this.enrollment.DISENROLLNOTICEDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')

        this.showSepEffDate = this.enrollment.SEPEFFDT == undefined ? false : true
        this.userPofilename = this._portalGlobal.currentUser.userProfileName
        if (this._portalGlobal.selectedPlanYear > this._portalGlobal.Planyear2024) {
            this.visibleFrom2025 = true
        } else {
            this.visibleFrom2025 = false
        }
        if (this.enrollment !== undefined) {
            if (this.enrollment.EFTTYPE === 'S') {
                this.AccountType = 'Savings'
            } else if (this.enrollment.EFTTYPE === 'C') {
                this.AccountType = 'Checking'
            } else {
                this.AccountType = this.enrollment.EFTTYPE
            }
            this.gender = this.enrollment.APPGEN === 'M' ? 'Male' : 'Female'
            // get Agent Name in Agent ID & Data Entry ID
            this.AgentName = this.enrollment.AGENTID
            this.DataEntryAgentName = String(this.enrollment.ADMINID)
            this.PaperlessOption = this.enrollment.PaperlessSettings
            if (this.enrollment.EOB !== undefined) {
                if (
                    this.enrollment.EOB.toString().toUpperCase() === 'EEOB' ||
                    this.enrollment.EOB === '5' ||
                    this.enrollment.EOB === '6' ||
                    this.enrollment.EOB === '7' ||
                    this.enrollment.EOB === '9'
                ) {
                    this.EOBFlag = 'Yes'
                } else {
                    this.EOBFlag = 'No'
                }

                if (this.enrollment.ISSINGLEGROUP) {
                    this.EOBFlag = ''
                }

                if (this.enrollment.EOB === '1' || this.enrollment.EOB === '5') {
                    this.Accessible = 'Large Print'
                } else if (this.enrollment.EOB === '2' || this.enrollment.EOB === '6') {
                    this.Accessible = 'Braille'
                } else if (this.enrollment.EOB === '4' || this.enrollment.EOB === '7') {
                    this.Accessible = 'Audio CD'
                } else if (this.enrollment.EOB === '8' || this.enrollment.EOB === '9') {
                    this.Accessible = 'Data CD'
                } else {
                    this.Accessible = ''
                }
            } else {
                this.EOBFlag = ''
                this.Accessible = ''
            }
        }
    }

    formSubmit(): void {
        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
        this.updateDataServiceCall('/' + insCo + '/enrollment/external-agent/Step5')
    }

    goBack(): void {
        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step3'])
    }

    updateDataServiceCall(route: string) {
        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this.enrollment.ISSINGLEGROUP) {
            this.enrollment.SUBMISSIONTYPECODE = 'COMPLETE'
            this.enrollment.STEPCODE = '4'
            
            this.loading = true
            this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe(
                (model: SubmitEnrollmentDataResponse) => {
                    let response = model
                    if (response !== undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            this.hasError = false

                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            window.scrollTo(0, 0)
                        } else {
                            if (
                                response.confirmationNumber !== undefined &&
                                response.confirmationNumber !== null &&
                                response.confirmationNumber !== ''
                            ) {
                                this.enrollment.CONF = response.confirmationNumber
                                this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                this.loading = false
                                this.router.navigate([route])
                            } else {
                                this.ErrorMessages.push('Error while submitting data, please try again.')
                                window.scrollTo(0, 0)
                            }
                        }
                    } else {
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        window.scrollTo(0, 0)
                    }
                    this.loading = false
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.router.navigate(['/' + insCo + '/enrollment/external-agent/CheckList'])
        }
    }
}
